<template>
  <div>
    <div>
      <v-icon v-if="prependIcon">{{ prependIcon }}</v-icon>
      {{ field.label }}
    </div>
    <v-tabs>
      <v-tab :href="`#edit`" :key="`edit`">Редактирование </v-tab>
      <v-tab :href="`#html`" :key="`html`">HTML </v-tab>
      <v-tab-item :key="`edit`" :value="`edit`">
        <div class="mb-4">
          <video-modal
            ref="videoModal"
            @onConfirm="onVideoConfirm"
          ></video-modal>
          <editor-menu-bar
            :editor="editor"
            v-slot="{ commands, isActive, getMarkAttrs }"
          >
            <div class="editor-menu-bar">
              <v-btn icon @click="openVideoModal(commands.iframe)">
                <v-icon>video_library</v-icon>
              </v-btn>
              <v-btn icon @click="commands.bold">
                <v-icon :color="isActive.bold() ? 'black' : 'grey'"
                  >format_bold</v-icon
                >
              </v-btn>
              <v-btn icon @click="commands.italic">
                <v-icon :color="isActive.italic() ? 'black' : 'grey'">
                  format_italic
                </v-icon>
              </v-btn>
              <v-btn icon @click="commands.heading({ level: 1 })">
                <span
                  :color="isActive.heading({ level: 1 }) ? 'black' : 'grey'"
                >
                  H1
                </span>
              </v-btn>
              <v-btn icon @click="commands.heading({ level: 2 })">
                <span
                  :color="isActive.heading({ level: 2 }) ? 'black' : 'grey'"
                >
                  H2
                </span>
              </v-btn>
              <v-btn icon @click="commands.heading({ level: 3 })">
                <span
                  :color="isActive.heading({ level: 3 }) ? 'black' : 'grey'"
                >
                  H3
                </span>
              </v-btn>
              <v-btn icon @click="commands.bullet_list()">
                <v-icon :color="isActive.bullet_list() ? 'black' : 'grey'">
                  format_list_bulleted
                </v-icon>
              </v-btn>
              <v-btn icon @click="commands.ordered_list()">
                <v-icon :color="isActive.ordered_list() ? 'black' : 'grey'">
                  format_list_numbered
                </v-icon>
              </v-btn>
              <v-btn icon @click="commands.underline()">
                <v-icon :color="isActive.underline() ? 'black' : 'grey'">
                  format_underlined
                </v-icon>
              </v-btn>
              <v-btn icon @click="commands.strike()">
                <v-icon :color="isActive.strike() ? 'black' : 'grey'">
                  strikethrough_s
                </v-icon>
              </v-btn>
              <v-btn icon @click="showImagePrompt(commands.image)">
                <v-icon>
                  add_photo_alternate
                </v-icon>
              </v-btn>
              <v-btn
                icon
                @click="showImagePrompt(commands.image, (on_link = true))"
              >
                <v-icon>
                  image
                </v-icon>
              </v-btn>

              <input
                class="input_upload"
                ref="image_input"
                type="file"
                accept="image/jpeg,image/png,image/gif"
                @change="onUploadImage($event, commands.image)"
              />

              <v-btn
                icon
                class="menububble__button"
                @click="
                  showLinkMenu(getMarkAttrs('link'), (upload_file = true))
                "
                :class="{ 'is-active': isActive.link() }"
              >
                <v-icon>insert_drive_file</v-icon>
              </v-btn>

              <input
                class="input_upload"
                ref="file_input"
                type="file"
                @change="onUploadFile($event, commands.link)"
              />

              <!-- Иконки работы с таблицами -->
              <div class="editor-menu-bar">
                <v-btn
                  icon
                  @click="
                    commands.createTable({
                      rowsCount: 3,
                      colsCount: 3,
                      withHeaderRow: false
                    })
                  "
                >
                  <img :src="getIcon('table')" width="20" height="20" />
                </v-btn>

                <span v-if="isActive.table()">
                  <v-btn icon @click="commands.deleteTable">
                    <img
                      :src="getIcon('delete_table')"
                      width="20"
                      height="20"
                    />
                  </v-btn>
                  <v-btn icon @click="commands.addColumnBefore">
                    <img
                      :src="getIcon('add_col_before')"
                      width="20"
                      height="20"
                    />
                  </v-btn>
                  <v-btn icon @click="commands.addColumnAfter">
                    <img
                      :src="getIcon('add_col_after')"
                      width="20"
                      height="20"
                    />
                  </v-btn>
                  <v-btn icon @click="commands.deleteColumn">
                    <img :src="getIcon('delete_col')" width="20" height="20" />
                  </v-btn>
                  <v-btn icon @click="commands.addRowBefore">
                    <img
                      :src="getIcon('add_row_before')"
                      width="20"
                      height="20"
                    />
                  </v-btn>
                  <v-btn icon @click="commands.addRowAfter">
                    <img
                      :src="getIcon('add_row_after')"
                      width="20"
                      height="20"
                    />
                  </v-btn>
                  <v-btn icon @click="commands.deleteRow">
                    <img :src="getIcon('delete_row')" width="20" height="20" />
                  </v-btn>
                  <v-btn icon @click="commands.toggleCellMerge">
                    <img
                      :src="getIcon('combine_cells')"
                      width="20"
                      height="20"
                    />
                  </v-btn>
                </span>
              </div>
            </div>
          </editor-menu-bar>
          <editor-menu-bubble
            class="menububble editor-menu-bubble"
            :editor="editor"
            @hide="hideLinkMenu"
            v-slot="{ commands, isActive, getMarkAttrs, menu }"
          >
            <div
              class="menububble"
              :class="{ 'is-active': menu.isActive }"
              :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
            >
              <form
                class="menububble__form"
                v-if="linkMenuIsActive"
                @submit.prevent="setLinkUrl(commands.link, linkUrl)"
              >
                <v-btn
                  class="menububble__button"
                  @click="setLinkUrl(commands.link, null)"
                  type="button"
                >
                  <input
                    class="menububble__input"
                    type="text"
                    v-model="linkUrl"
                    placeholder="https://"
                    ref="linkInput"
                    @keydown.esc="hideLinkMenu"
                  />
                  <v-icon>link_off</v-icon>
                </v-btn>
              </form>

              <template v-else>
                <v-btn
                  icon
                  class="menububble__button"
                  @click="showLinkMenu(getMarkAttrs('link'))"
                  :class="{ 'is-active': isActive.link() }"
                >
                  <v-icon>link</v-icon>
                </v-btn>
              </template>
            </div>
          </editor-menu-bubble>
          <editor-content :editor="editor" class="editor-content" />
        </div>
      </v-tab-item>

      <v-tab-item :key="`html`" :value="`html`">
        <v-textarea :label="field.label" :value="value" @input="updateValue">
        </v-textarea>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from "tiptap";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image,
  Focus,
  Table,
  TableHeader,
  TableCell,
  TableRow
} from "tiptap-extensions";
import Iframe from "@/plugins/tiptap_iframe.js";
import VideoModal from "../VideoModal";
import images from "./../../api/images";
import config from "../../config";

export default {
  name: "TiptapField",
  props: ["field", "value"],
  components: { EditorContent, EditorMenuBar, EditorMenuBubble, VideoModal },
  data() {
    return {
      editor: new Editor({
        content: this.value,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(),
          new Focus({
            className: "has-focus",
            nested: true
          }),
          new Iframe(),

          new Table({
            resizable: true
          }),
          new TableHeader(),
          new TableCell(),
          new TableRow()
        ]
      }),
      linkUrl: null,
      linkMenuIsActive: false
    };
  },
  computed: {
    prependIcon() {
      if (this.field.translatable) return "language";
      return "";
    }
  },
  methods: {
    getIcon(image) {
      return require(`@/assets/icons/${image}.svg`);
    },

    updateValue(text) {
      this.editor.setContent(text);
      this.$parent.entity[this.field.name] = text;
    },

    openVideoModal(command) {
      this.$refs.videoModal.open(command);
    },
    onVideoConfirm(data) {
      console.log("COMMAND", data);
      data.command(data.data);
    },
    showLinkMenu(attrs, upload_file = false) {
      if (upload_file) {
        this.$refs.file_input.click();
      } else {
        this.linkUrl = attrs.href;
        this.linkMenuIsActive = true;
        this.$nextTick(() => {
          this.$refs.linkInput.focus();
        });
      }
    },
    hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl(command, url) {
      command({ href: url });
      this.hideLinkMenu();
      this.editor.focus();
    },

    showImagePrompt(command, on_link = false) {
      if (!on_link) {
        this.$refs.image_input.click();
      } else {
        const src = prompt("Введите адрес картинки");
        if (src !== null) command({ src });
      }
    },

    async onUploadImage(e, command) {
      let image = e.target.files[0];
      const result = await images.upload(this.token, image);
      if (result.success) {
        let src = config.imagesBaseUrl + `/upload/tmp/${result.filename}`;
        command({ src });
      }
    },

    async onUploadFile(e, command) {
      let file = e.target.files[0];
      const result = await images.upload(this.token, file);
      if (result.success) {
        let src = config.imagesBaseUrl + `/upload/tmp/${result.filename}`;
        command({ href: src });
        // If you select the same file, the onChange event of input[type=file] will not fire.
        e.target.value = "";
      }
    }
  },

  beforeDestroy() {
    this.editor.destroy();
  },
  mounted() {
    this.editor.on("update", ({ getHTML }) => {
      this.$parent.entity[this.field.name] = getHTML();
    });
  }
};
</script>
<style scoped>
.editor-menu-bar {
  background-color: aliceblue;
}
.editor-content {
  background-color: white;
  border: 2px solid aliceblue;
}
.editor-menu-bubble {
  background-color: aliceblue;
}
.has-focus {
  border-radius: 3px;
  box-shadow: 0 0 0 3px #3ea4ffe6;
}
.input_upload {
  display: none;
}
</style>
